import { Form, Button } from "react-bootstrap";
import "./Contact_us.css";
import { useEffect, useState } from "react";
import Full_screen_modal from "../common/full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../common/lotties/success_lottie/Success_lottie";
import { useNavigate } from "react-router-dom";
import { Contactus } from "../../utils/apis/contact-us/ContactUs";
import { PowerProgress } from "../../utils/apis/homepage";

const Contact_us = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    whatsapp_no: "",
    city: "",
    pincode: "",
    message: "",
    privacy_policy: false,
  });

  const [errors, setErrors] = useState({});
  const [showMap, setShowMap] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        setShowModal(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showModal]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "whatsapp_no") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    if (name === "pincode") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 6) return;
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    const e = {};

    //if (!formData.name.trim()) e.name = "Name is required";

    if (!formData.first_name.trim()) e.first_name = "First name is required";

    if (!formData.last_name.trim()) e.last_name = "Last name is required";

    if (!formData.city.trim()) e.city = "City is required";

    if (!formData.whatsapp_no) e.whatsapp_no = "WhatsApp number required";
    else if (formData.whatsapp_no.length !== 10)
      e.whatsapp_no = "Enter valid 10 digit number";

    if (!formData.pincode) e.pincode = "Pincode required";
    else if (formData.pincode.length !== 6)
      e.pincode = "Enter valid 6 digit pincode";

    if (!formData.message.trim()) e.message = "Message is required";

    if (!formData.privacy_policy)
      e.privacy_policy = "Please accept privacy policy";

    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      ...formData,
      name: `${formData.first_name} ${formData.last_name}`, //merge
    };

    delete payload.first_name;
    delete payload.last_name;

    const res = await Contactus(formData);

    if (res?.success) {
      setShowModal(true);

      setFormData({
        first_name: "",
        last_name: "",
        whatsapp_no: "",
        city: "",
        pincode: "",
        message: "",
        privacy_policy: false,
      });

      setErrors({});
    }
  };

  const [appsetup, setAppSetup] = useState({});

  const getAppSetup = async () => {
    const res = await PowerProgress();

    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  return (
    <>
      <section className="contact_us_section container">
        <div className="contact_us_banner">
          <img
            src="/assets/images/contact-us/contact-banner.png"
            alt="Contact Banner"
            className="Banner_Image"
          />
        </div>

        <div className="contact_us_container">
          <Form className="contact_us_form" onSubmit={handleSubmit}>
            <div className="form_row">
              <div className="form_group">
                <Form.Label>
                  First Name<span>*</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  name="first_name"
                  value={formData?.first_name}
                  onChange={handleChange}
                  placeholder="Enter First Name*"
                />

                {errors.first_name && (
                  <p style={{ color: "red" }}>{errors.first_name}</p>
                )}
              </div>

              <div className="form_group">
                <Form.Label>
                  Last Name<span>*</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  name="last_name"
                  value={formData?.last_name}
                  onChange={handleChange}
                  placeholder="Enter Last Name*"
                />

                {errors.last_name && (
                  <p style={{ color: "red" }}>{errors.last_name}</p>
                )}
              </div>

              <div className="form_group">
                <Form.Label>
                  WhatsApp No <span>*</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  name="whatsapp_no"
                  value={formData.whatsapp_no}
                  onChange={handleChange}
                  placeholder="Enter No.*"
                  maxLength={10}
                />

                {errors.whatsapp_no && (
                  <p style={{ color: "red" }}>{errors.whatsapp_no}</p>
                )}
              </div>
            </div>

            <div className="form_row">
              <div className="form_group">
                <Form.Label>
                  Enter City<span>*</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Enter City*"
                />

                {errors.city && <p style={{ color: "red" }}>{errors.city}</p>}
              </div>

              <div className="form_group">
                <Form.Label>
                  Pin code<span>*</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  placeholder="eg. 453722*"
                  maxLength={6}
                />

                {errors.pincode && (
                  <p style={{ color: "red" }}>{errors.pincode}</p>
                )}
              </div>
            </div>

            <div className="form_group full_width">
              <Form.Label>
                Your message<span>*</span>
              </Form.Label>

              <Form.Control
                as="textarea"
                rows={3}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Type your message here...*"
              />

              {errors.message && (
                <p style={{ color: "red" }}>{errors.message}</p>
              )}
            </div>

            <div className="checkbox_row">
              <Form.Check
                type="checkbox"
                name="privacy_policy"
                checked={formData.privacy_policy}
                onChange={handleChange}
                label="I have read and agree to the Privacy Policy.*"
              />
            </div>
            {errors.privacy_policy && (
              <p style={{ color: "red" }}>{errors.privacy_policy}</p>
            )}

            <Button type="submit" className="send_btn">
              Send Message
            </Button>
          </Form>

          <div className="contact_us_info">
            <div className="info_item">
              <i className="fa-solid fa-phone info_icon"></i>
              <a
                href={`https://wa.me/${appsetup.contactno}`}
                target="_blank"
                rel="noopener noreferrer"
                className="link_text" 
              >
                {appsetup.contactno}
              </a>
            </div>

            <div className="info_item">
              <i className="fa-solid fa-envelope info_icon"></i>
              <a className="link_text" href={`mailto:${appsetup.email}`}>{appsetup.email}</a>
            </div>
            <div className="info_item">
              <i className="fa-solid fa-location-dot info_icon"></i>
              <p>{appsetup.address}</p>
            </div>

            {/* <div
              className="info_item map_link"
              onClick={() => setShowMap((prev) => !prev)}
              style={{ cursor: "pointer" }}
            >
              <i className="fa-solid fa-map info_icon"></i>
              <p>Find Us on Map</p>
            </div> */}

            {showMap && (
              <div
                className="map_wrapper"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0,0,0,0.8)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  className="map_close_btn"
                  onClick={() => setShowMap(false)}
                >
                  &times;
                </button>

                <div className="map_section">
                  <iframe
                    title="Location Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.996737526875!2d73.3115283148815!3d16.993820488917813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1ca9a7c6500df%3A0x633b20c295b77a52!2s1024%20Green%20House%2C%20Naik%20Nagar%2C%20Karwanchi%20Wadi%2C%20Pomendi%20Budruk%2C%20Ratnagiri%2C%20Maharashtra%20415612!5e0!3m2!1sen!2sin!4v1697269658462!5m2!1sen!2sin"
                    width="100%"
                    height="500"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <Full_screen_modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Success_lottie />}
      />
    </>
  );
};

export default Contact_us;
